import * as types from "./types";

export const defaultState = {
  users: {},
  loading: false,
  users_loading: {},
  errors: []
};

const users = (state = defaultState, action) => {
  switch (action.type) {
    case types.FETCHED_USER:
    case types.UPDATED_USER:
      let existent_users = { ...state.users };
      existent_users[action.user.guid] = action.user;
      return {
        ...state,
        users: existent_users,
        users_loading: { ...state.users_loading, [action.user["guid"]]: false },
        loading: action.loading
      };
    case types.FETCHING_USER:
      return {
        ...state,
        loading: action.loading,
        users_loading: { ...state.users_loading, [action.user_guid]: true }
      };
    case types.UPDATING_USER:
    case types.UPDATING_USER_COMPLETE:
    case types.RESENDING_ACTIVATION_EMAIL:
      return {
        ...state,
        loading: action.loading
      };
    case types.ERROR_FETCHING_USER:
    case types.ERROR_UPDATING_USER:
    case types.ERROR_RESET_USER_PASSWORD:
    case types.ERROR_RESENDING_ACTIVATION_EMAIL:
      return {
        ...state,
        errors: [...state.errors, action.error],
        loading: action.loading
      };
    default:
      return state;
  }
};
export default users;
